import React from "react";
import { observer } from "mobx-react";
import { IntentCtaBlock, Link } from "../../models/IntentSlideUpBoxModel";
import ImgLazyLoad from "../ImgLazyLoad";

interface IntentCtaProps {
  content: IntentCtaBlock;
  modelName: string;
}

interface IntentCtaState {
  content: IntentCtaBlock;
  modelName: string;
}

@observer
export default class IntentCta extends React.Component<
  IntentCtaProps,
  IntentCtaState
> {
  articlesPerPage: number = 5;
  startScrollPosition: number = null;

  constructor(props: IntentCtaProps) {
    super(props);

    this.state = {
      content: this.props.content,
      modelName: this.props.modelName,
    };
  }

  handleOnClick = (ctaDetails: Link, model: string): void => {
    if (ctaDetails.name.toLocaleLowerCase() === "download a brochure") {
      window["pushDigitalData"](
        {
          event: "_formNavigate",
          form: {
            name: "download a brochure",
            stage: "submitted",
            details: {
              vehicleSelected: [
                {
                  make: "Subaru",
                  model: model,
                },
              ],
            },
          },
        },
        true
      );
    }
    window.open(ctaDetails.url, ctaDetails.target || "_self");
  };

  componentDidMount() {}

  render() {
    const isMobileOrSmallTablet = window.innerWidth < 992;
    const { content, modelName } = this.state;
    const { ctaIconImage, cTaIconImageMobile, intentCtadetails } = content;

    return (
      <div
        className="IntentCtaContainer"
        onClick={(e) => this.handleOnClick(intentCtadetails, modelName)}
      >
        <div className="IntentCtaIconContainer">
          <ImgLazyLoad
            className="IntentCtaIcon CtaIconDesktop"
            src={ctaIconImage}
          />
          <ImgLazyLoad
            className="IntentCtaIcon CtaIconMobile"
            src={cTaIconImageMobile}
          />
        </div>
        <div className="IntentCtaButtonContainer">
          {isMobileOrSmallTablet ? (
            <span className="intetnCtaNameMobile">{intentCtadetails.name}</span>
          ) : (
            <div>
              <button
                type={"primary"}
                className="btn IntentCtaButton btn--primary"
              >
                {intentCtadetails.name}
              </button>
            </div>
          )}
        </div>
      </div>
    );
  }
}
